const IN_BROWSER = typeof window !== 'undefined'
const VUE_APP_APIPATH = process.env.VUE_APP_APIPATH

module.exports = {
  IN_BROWSER,
  VUE_APP_APIPATH,
}
